import authReducer from './authReducer'
export default authReducer